import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {DashboardComponent} from './dashboard';
import {routing} from './app.routing';
import {CoreModule} from './core/core.module';
import {PreviewModule} from './preview/preview.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from './shared/shared.module';
import {ExternalLinkService} from './external-link/external-link.service';
import {ExternalLinkGuard} from './external-link/external-link-guard';
import {SidebarModule} from "primeng/sidebar";
import {NotificationModule} from "./notification/notification.module";
import {InternalLinkService} from "./internal-link/internal-link.service";
import {ObiektIdLinkGuard} from "./internal-link/obiekt-id-link-guard";
import {IdentyfikatorAktuLinkGuard} from "./internal-link/identyfikator-aktu-link-guard";
import {SharedGenericModule} from './shared/shared-generic/shared-generic.module';
import {provideHttpClient, withXsrfConfiguration} from "@angular/common/http";
import {environment} from "../environments/environment";
import {ListAndMetadataPreviewModule} from "./list-and-metadata-preview/list-and-metadata-preview.module";

@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        CoreModule,
        routing,
        PreviewModule,
        SharedGenericModule,
        SharedModule,
        SidebarModule,
        NotificationModule,
        ListAndMetadataPreviewModule], providers: [
        ExternalLinkService,
        ExternalLinkGuard,
        InternalLinkService,
        ObiektIdLinkGuard,
        IdentyfikatorAktuLinkGuard,
        provideHttpClient(withXsrfConfiguration({
            cookieName: environment.xsrfCookieName,
            headerName: environment.xsrfHeaderName
        }))
    ]
})
export class AppModule {
}
